import type {ThemeIconKey} from 'platform/foundation';

export const ADVERTISEMENT_PREVIEW_SECTION_ICONS: Record<
  'overview' | 'details' | 'features' | 'description',
  ThemeIconKey
> = {
  overview: 'image/images_stroke',
  details: 'action/settings_2_stroke',
  features: 'content/list_checks_stroke',
  description: 'content/file_text_stroke',
};
